import {Tabs, Divider, Space, Card} from "antd";
import React, {useMemo} from "react";
import PlotlyStockChart from "../../../charts/Plotly/PlotlyStockChart";
import {sampleModernColors} from "../../../utils/colors";
import usePdfExport from "../../../hooks/usePdfExport";
import BlotterSnapshot from "./BlotterSnapshot";
import PortfolioXray from "../../Experiments/PortfolioXray";
import Chip from "../../../components/Chip";


function parseDelimitedResponse(text) {
    const sections = [];
    let currentSection = null;

    // Use a regular expression to find sections marked by ---<TEXT>---
    const lines = text.split('\n'); // Split by newlines for easier line-by-line processing
    const sectionRegex = /---(.+?)---/; // Matches the ---<TEXT>--- pattern

    lines.forEach(line => {
        const sectionMatch = line.match(sectionRegex);

        if (sectionMatch) {
            // If there's an existing section, push it to the sections array
            if (currentSection) {
                sections.push(currentSection);
            }

            // Start a new section with the found title
            currentSection = { title: sectionMatch[1].trim(), content: '' };
        } else if (currentSection) {
            // Append line content to the current section
            currentSection.content += line.trim() + ' ';
        }
    });

    // Push the last section if it exists
    if (currentSection) {
        sections.push(currentSection);
    }

    return sections;
}




const combineTextAndData = (textParts, data) => {
    const mergedData = []
    const dataHeaders = data.slice(0);
    const fixedHeaders = dataHeaders.slice(0, 4); // Includes date, portfolio, snapshot, benchmark
    const extraHeaders = dataHeaders.slice(4, ); // All extra tickers
    const dataBody = data.slice(1, );
    const textBody = textParts.slice(1, );


    for (let i = 0; i < dataBody.length; i++) {
        const row = dataBody[i];
        const text = textBody[i];
        let payload = {
            text,
            portfolio: row[1],
            snapshot: row[2],
            benchmark: row[3],
            timestamp: row[0],
        }
        if (extraHeaders && extraHeaders.length > 0) {
            const holdings = {}
            console.log(extraHeaders)
            extraHeaders.forEach((header, index) => {
                holdings[header] = row[index + 4];
            });
            console.log(holdings)
            payload.holdings = holdings;
        }
        mergedData.push(payload);
    }
    return mergedData;

}




const BlotterResponse = ({response, data, closeResponse, extraDetails, timeSeriesData })=>{
    console.log(data)
    console.log(extraDetails)
    const onTabChange = (key) => {
        if (key === '0') {
            closeResponse?.();
        }
    }
    const textParts = parseDelimitedResponse(response.data);
    const { exportToPDF, componentRef, isExporting } = usePdfExport();

    const mergedData = combineTextAndData(textParts, data);
    const uniqueTickers = useMemo(() => {
        const tickersSet = new Set();
        mergedData.forEach(x => {
            const snapshot = x.snapshot;
            Object.keys(snapshot).forEach((ticker) => {
                tickersSet.add(ticker);
            });
        });
        return Array.from(tickersSet);
    }, [mergedData]);

    const snapshotData = [...data].map((x, index)=>({
        key: x[0],
        name: x[0],
        ptfl: x[2],
        extra: extraDetails.length > 0 && <Chip label={"Beta"} value={`${(extraDetails[index]?.beta*100).toFixed(2)}%`} />
    }))

    // Step 2: Assign colors to each unique ticker
    const colorMap = useMemo(() => {
        const colors = sampleModernColors(uniqueTickers.length);
        let mapping = {};
        uniqueTickers.forEach((ticker, i) => {
            mapping[ticker] = colors[i];
        });
        return mapping;
    }, [uniqueTickers]);
    const selectedDates = mergedData && mergedData.map(x=>x.timestamp);

    return (

        <Tabs defaultActiveKey="1" tabPosition={'left'} onChange={onTabChange}>
            <Tabs.TabPane key={'0'} tab={'Back to Chart'} />
            <Tabs.TabPane key={'1'} tab={'Talking Points'}>
                <div style={{maxWidth: 1600}}>
                    <Card>
                        <div style={{height: '40vh', width: '100%'}}>
                            <PlotlyStockChart
                                timeseriesData={timeSeriesData}
                                disableAnnotations={false}
                                disableScrollbar={true}
                                verticalLines={selectedDates}
                                disableToolbar={true}
                            />
                        </div>
                    </Card>

                    <Divider/>
                    <div ref={componentRef}> {/* Wrap snapshot content with ref */}

                        <Space direction={'vertical'}>
                            {mergedData.map((row, index) => (
                                <div className={'py-6'}>
                                    <BlotterSnapshot
                                        data={row}
                                        colorMap={colorMap}
                                    />
                                    <Divider/>
                                </div>
                            ))}
                        </Space>
                    </div>
                </div>
            </Tabs.TabPane>
            <Tabs.TabPane key={'3'} tab={'New Points'}>
                <PortfolioXray portfolios={snapshotData}  />
            </Tabs.TabPane>

        </Tabs>

    )
}

export default BlotterResponse;
